<template>
  <div>
    <el-table :data="list">
      <el-table-column width="100" prop="name" label="标签组"></el-table-column>
      <el-table-column label="标签">
        <template slot-scope="scope">
          <div class="groups">
            <div v-for="(tag,i2) in scope.row.tags"
                 :key="i2"
                 :class="['tag', tagIds.includes(tag.id) ? 'tag-activate' : '']"
                 @click="handleTagClick(tag.id)">
              {{ tag.name }}
            </div>
          </div>
        </template>
        <template slot="header" slot-scope="scope">
          <el-button size="mini" type="primary" @click="saveTag(id)" v-if="!utils.array.equals(tagIds, tagIdsOld)">
            保存更改
          </el-button>
          <div v-else class="info-text">请点击标签进行更新</div>
        </template>
      </el-table-column>

    </el-table>
  </div>

</template>

<script>
import {miuTag} from "@/api/miu/tag";
import {utils} from "@/util/utils";
import {miuTeacherService} from "@/api/miu/teacherService";

export default {
  name: "TeacherServiceTagEdit",
  computed: {
    utils() {
      return utils;
    },
  },
  props: {
    id: Number,
    tagGroups: Array,
  },
  data() {
    return {
      list: [],
      tagIdsOld: [],

      // 当前的标签
      tagIds: [],
      selectedTagNames: [],
    };
  },
  methods: {
    saveTag() {
      miuTeacherService.updateMiuTeachProductTag(this.id, this.tagIds).then(res => {
        if (res.code === 200) {
          this.$emit("updated");
          this.tagIdsOld = utils.obj.deepClone(this.tagIds);
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    handleTagClick(tagId) {
      if (this.tagIds.includes(tagId)) {
        this.tagIds = this.tagIds.filter((id) => id !== tagId);
      } else {
        this.tagIds.push(tagId);
      }
    },

    getData() {
      let tagIds = [];

      console.log(this.tagGroups);

      this.tagGroups?.map((item) => {
        let tagIdsTemp = item.tags.map(tagItem => tagItem.id);
        console.log("tagIdsTemp:");
        console.log(tagIdsTemp);
        tagIds.push(...tagIdsTemp);
      });


      console.log("tagIds:");
      console.log(tagIds);

      this.tagIds = tagIds;
      this.tagIdsOld = utils.obj.deepClone(tagIds);
    },
  },

  created() {
    miuTag.list("product").then((res) => {
      this.list = res.data;
    });
    this.getData();
  },
};
</script>

<style scoped>
.groups {
  display: flex;
  flex-flow: row;
  gap: 12px;
  flex-wrap: wrap;

}

.group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  background: #f4f4f4;
  padding: 4px 8px;
  border-radius: 8px;
  color: #a6a6a6;
  -webkit-user-select: none;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
}

.tag:hover {
  background: #939393;
  color: #fff;
}

.tag-activate {
  background: #4a90e2;
  color: #fff;
}

</style>
